import { useApi } from '@api/ApiProvider'
import { ApiError } from '@api/client'
import { useI18n } from '@i18n/I18nProvider'
import { Icon } from '@ui/Icon'
import { ErrorState, LoadingState } from '@ui/States'
import { Link } from 'wouter'
import { ReportCard } from './ReportCard'
import { usePanelQuery } from './StaffSession'
import { useNames } from './useNames'

// Historial de avisos de un árbol (también si ya está retirado), del más reciente al más antiguo.
export const TreeHistoryPage = ({ code }: { code: string }) => {
	const { t } = useI18n()
	const api = useApi()
	const names = useNames()
	const history = usePanelQuery(['tree-history', code], (token) => api.treeHistory(token, code))

	return (
		<>
			<Link
				href="/arboles"
				className="mb-2 inline-flex min-h-12 items-center gap-1 font-semibold text-forest-800"
			>
				<Icon name="back" className="size-5" />
				{t('panel.trees')}
			</Link>
			<h2 className="mb-3 text-2xl font-semibold">{t('history.title', { code })}</h2>
			{history.isPending ? (
				<LoadingState shape="list" />
			) : history.error instanceof ApiError && history.error.isNotFound ? (
				<p className="py-8 text-center text-lg text-earth-800">{t('history.notFound', { code })}</p>
			) : !history.data ? (
				<ErrorState error={history.error} onRetry={() => history.refetch()} />
			) : (
				<>
					{history.data.retired ? (
						<p className="mb-4 rounded-2xl bg-earth-100 p-4 font-semibold">{t('history.retired')}</p>
					) : (
						<Link
							href={`~/a/${encodeURIComponent(history.data.code)}`}
							className="mb-4 inline-flex min-h-12 items-center gap-1 font-semibold text-forest-800 underline underline-offset-4"
						>
							{t('history.publicPage')}
						</Link>
					)}
					{history.data.reports.length === 0 ? (
						<p className="py-8 text-center text-lg text-earth-800">{t('history.empty')}</p>
					) : (
						<ul className="grid gap-3">
							{history.data.reports.map((report) => (
								<li key={report.id}>
									<ReportCard
										report={report}
										municipality={names.municipality(report.municipalityId)}
										linkTree={false}
									/>
								</li>
							))}
						</ul>
					)}
				</>
			)}
		</>
	)
}
